module.exports = __webpack_public_path__ + "img/img50.916b94b4.png";